var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-lg-flex align-items-center justify-content-center"},[_c('b-img',{attrs:{"fluid":"","src":_vm.imgLogo,"alt":"logo axismedical"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }